<template>
  <van-pull-refresh
    v-model="isLoading"
    @refresh="onRefresh"
    :pulling-text="$t('tips.pullrefresh')"
    :loosing-text="$t('tips.loosingrefresh')"
    :loading-text="$t('tips.loading')"
  >
    <van-search v-model="searchcontent" :placeholder="$t('member.search')" />
    <van-list
      class="indexuserBox"
      v-model:loading="loading"
      :finished="finished"
      :finished-text="$t('tips.nomore')"
      @load="onLoad"
      :immediate-check="false"
    >
      <User
        v-for="(item, index) in data"
        :key="index"
        :item="item"
        @follow="item.is_like = item.is_like == 0 ? 1 : 0"
      />
    </van-list>
  </van-pull-refresh>
</template>

<script>
import User from "./User.vue";
import { ElLoading } from "element-plus";
export default {
  data() {
    return {
      isLoading: false,
      searchcontent: "",
      setTimeout: null,
      data: [],
      loading: true,
      finished: false,
      page: 1,
      last_page: 0,
      loadingInstance: null,
    };
  },
  watch: {
    searchcontent(oldValue, newValue) {
      if (this.util.checkPermision("Search_users")) {
        clearTimeout(this.setTimeout);
        this.setTimeout = setTimeout(this.search, 500);
      }
    },
  },
  components: {
    User,
  },
  methods: {
    onRefresh() {
      this.search();
      setTimeout(() => {
        this.isLoading = false;
      }, 500);
    },
    follow() {
      ElMessage.success(this.$t("tips.followsuccess"));
    },
    search() {
      this.page = 1;
      this.loading = true;
      this.getUserList();
    },
    onLoad() {
      this.loading = true;
      if (this.data.length == 0) {
        this.page = 1;
      }
      if (this.page < this.last_page) {
        this.page++;
        this.getUserList();
      } else {
        this.finished = true;
        setTimeout(() => {
          this.loading = false;
        }, 1000);
      }
    },
    getUserList() {
      var page = this.page;
      this.axios
        .post_form("/member/index/userlist", {
          page: page,
          username: this.searchcontent,
        })
        .then((res) => {
          res = res.data;
          if (res.status == 200) {
            if (page == 1) {
              this.data = res.data.data;
            } else {
              this.data = this.data.concat(res.data.data);
            }
            this.last_page = res.data.last_page;
            this.loadingInstance.close();
            setTimeout(() => {
              this.loading = false;
            }, 300);
          }
        });
    },
  },
  created() {
    this.loadingInstance = ElLoading.service({ fullscreen: true });
    this.getUserList();
  },
};
</script>

<style lang="scss" scoped>
.indexuserBox {
  padding: 20px 0px;
  display: flex;
  flex-wrap: wrap;
  padding-bottom: 100px;
  min-height: 501px;
}
</style>

<style lang="scss">
.van-list__finished-text {
  text-align: center;
  width: 100%;
}
</style>
